import React from "react";
import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  Box,
  Fade,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { styled } from "@mui/material/styles";
import { resetDataAndLogout } from "../../../../helpers/auth";
import { useDispatch } from "react-redux";
import { logOut } from "../../../../redux/slices/loginSlice";
import { resetRoleRoute } from "../../../../redux/slices/UserRoute/UserRoleRouteSlice";

// Styled component for smooth hover effect
const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
  position: "relative",
  overflow: "hidden",
  // borderRadius: "8px",
  // margin: "8px",
  paddingLeft: "16px",
  transition: "all 0.3s ease",
  color: theme.palette.error.main,
  "&:hover": {
    backgroundColor: theme.palette.error.light,
    transform: "translateY(-2px)",
    // boxShadow: theme.shadows[2],
    "& .MuiTypography-root": {
      color: theme.palette.common.white,
    },
    "& .MuiSvgIcon-root": {
      color: theme.palette.error.main,
      transform: "scale(1.1)",
    },
  },
  // "&::before": {
  //   content: '""',
  //   position: "absolute",
  //   top: 0,
  //   left: 0,
  //   width: "4px",
  //   height: "100%",
  //   backgroundColor: theme.palette.error.light,
  //   transform: "scaleY(0)",
  //   transformOrigin: "bottom",
  //   transition: "transform 0.3s ease",
  // },
  // "&:hover::before": {
  //   transform: "scaleY(1)",
  // },
}));

const AnimatedLogoutIcon = styled(LogoutIcon)(({ theme }) => ({
  transition: "transform 0.3s ease, color 0.3s ease",
  color: theme.palette.error.main,
}));

export default function LogOut({ onClick }) {
  const dispatch = useDispatch();
  return (
    <Fade in timeout={800}>
      <Box>
        <StyledListItemButton
          onClick={() => {
            resetDataAndLogout();
            dispatch(logOut());
            dispatch(resetRoleRoute());
            window.location.href = "/";
          }}
        >
          <ListItemIcon sx={{ minWidth: 36 }}>
            <AnimatedLogoutIcon
              sx={{ color: (theme) => theme.palette.common.white }}
            />
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: 600,
                  transition: "color 0.3s ease",
                  color: (theme) => theme.palette.common.white,
                  // theme.palette.error.main,
                }}
              >
                Log Out
              </Typography>
            }
          />
        </StyledListItemButton>
      </Box>
    </Fade>
  );
}
